import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowDown, FiCheckCircle } = FiIcons;

function Hero() {
  const scrollToPrograms = () => {
    document.getElementById('programs')?.scrollIntoView({
      behavior: 'smooth',
    });
  };

  return (
    <header className="hero">
      <div className="hero-overlay" />
      <div className="hero-content">
        <p className="eyebrow">Tampa PTA Program Directory</p>
        <h1>Compare PTA Programs in Tampa</h1>
        <p className="hero-copy">
          Explore physical therapist assistant programs across Tampa Bay and
          nearby Florida communities, including public colleges, private
          schools, clinical education, credentials, costs, and important
          questions to ask before applying.
        </p>
        <button className="primary-button" onClick={scrollToPrograms}>
          Explore Tampa PTA Programs
          <SafeIcon icon={FiArrowDown} aria-hidden="true" />
        </button>
        <p className="trust-line">
          <SafeIcon icon={FiCheckCircle} aria-hidden="true" />
          Independent comparisons of PTA education, clinical preparation, costs,
          and locations
        </p>
      </div>
    </header>
  );
}

export default Hero;